import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
} from "../../components";
import { usePostCreateWorkOrderTest } from "../../hooks";
import { useDialogContext } from "../HubDialogWrapper";

import AddWorkOrderTesting from "./AddWorkOrderTesting";

export const AddWorkOrderTestingContent = ({ workOrderId }) => {
  const {
    mutate: createTests,
    isSuccess,
    isLoading,
  } = usePostCreateWorkOrderTest();
  const { onClose = () => {} } = useDialogContext();

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const tests = formData?.testing
      ?.map((t) => ({
        testId: t.testId,
        quantity: Number(t.quantity),
      }))
      .filter((t) => t.quantity);

    const payload = { id: workOrderId, tests };
    createTests(payload);
  };

  return (
    <HubDialogContent>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="25px">
          <Stack sx={{ span: { textAlign: "center" } }}>
            <Typography variant="boldCaptionL">Add Work Order Tests</Typography>
            <Typography variant="caption" noWrap>
              Add Work Order Test to Existing Work Order Tests
            </Typography>
          </Stack>
          <AddWorkOrderTesting />
          <HubCancelSubmitGroup
            disabled={isLoading}
            isLoading={isLoading}
            label="Add Tests"
            disableOnInvalid
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default AddWorkOrderTestingContent;
